let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hWNfo")).then(() => parcelRequire('72BhT'));